import {
  LEGACY_AFTERMARKET_END_MINUTES,
  LEGACY_PREMARKET_START_MINUTES,
  Quote,
  convertTa,
} from '../../../app/charts-lib'
import { ObjectHash } from '../../components/types'
import { getInstrumentForTicker } from '../../util'

const PADDING = 2 // Border widths

export function getChartsDimensions(chartElementId: string) {
  const containerElement = document.getElementById(chartElementId)

  const box = containerElement?.getBoundingClientRect()

  return {
    width: Math.max((box?.width ?? 0) - PADDING, 0),
    height: Math.max((box?.height ?? 0) - PADDING, 0),
  }
}

export function getIdeaChartConfigWithAdjustedPremarketAftermarket(chartConfig: ObjectHash) {
  for (let i = 0; i < chartConfig.charts.length; i++) {
    if (chartConfig.charts[i].premarket === true) {
      chartConfig.charts[i].premarket = LEGACY_PREMARKET_START_MINUTES
    } else if (chartConfig.charts[i].premarket === false) {
      chartConfig.charts[i].premarket = 0
    }
    if (chartConfig.charts[i].aftermarket === true) {
      chartConfig.charts[i].aftermarket = LEGACY_AFTERMARKET_END_MINUTES
    } else if (chartConfig.charts[i].aftermarket === false) {
      chartConfig.charts[i].aftermarket = 0
    }
  }
  return chartConfig
}

export function getChartConfig(idea: any, chartElementId: string) {
  const chartsDimensions = getChartsDimensions(chartElementId)

  if (idea) {
    const chartConfig = Object.assign({}, FinvizChartsSettings.ideaChart, {
      colors: FinvizChartsSettings.colors,
      width: chartsDimensions.width,
      height: chartsDimensions.height,
      scrollable: true,
      editors: ['layout', 'settings', 'publish', 'tools'],
    })
    for (let i = 0; i < chartConfig.charts.length; i++) {
      if (!chartConfig.charts[i].instrument) {
        chartConfig.charts[i].instrument = 'stock'
      }
    }

    return getIdeaChartConfigWithAdjustedPremarketAftermarket(chartConfig) as any
  }

  return {
    newCharts: true,
    width: chartsDimensions.width,
    height: chartsDimensions.height,
    barWidth: 3,
    barMargin: 1,
    scrollable: true,
    alignChartsToRight: true,
    theme: FinvizChartsSettings.theme,
    colors: FinvizChartsSettings.colors,
    editors: ['layout', 'settings', 'publish', 'tools'],
    layout: FinvizChartsSettings.layout,
    charts: FinvizChartsSettings.tickers.map(function (ticker: string, index: number) {
      return {
        timeframe: FinvizChartsSettings.periods[index],
        dateRange: FinvizChartsSettings.ranges[index],
        scale: FinvizChartsSettings.taConfig.scale || 'linear',
        ticker: ticker,
        instrument: getInstrumentForTicker(ticker),
        premarket: FinvizChartsSettings.taConfig.premarket,
        aftermarket: FinvizChartsSettings.taConfig.aftermarket,
        hasChartEvents: FinvizChartsSettings.taConfig.hasChartEvents,
        refreshData: true,
        panes: convertTa.getPanes(FinvizChartsSettings.taConfig),
      }
    }),
  }
}

export const initIdeaQuotes = (quotes: Array<ObjectHash>, ideaChart: ObjectHash) => {
  const hasPatterns = JSON.stringify(ideaChart).includes('patterns')

  for (let i = 0; i < quotes.length; i++) {
    const quote = quotes[i]

    if (quote.premarket === true) {
      quote.premarket = LEGACY_PREMARKET_START_MINUTES
    } else if (quote.premarket === false) {
      quote.premarket = 0
    }
    if (quote.aftermarket === true) {
      quote.aftermarket = LEGACY_AFTERMARKET_END_MINUTES
    } else if (quote.aftermarket === false) {
      quote.aftermarket = 0
    }

    if (quote.timeframe === 'i1' || quote.timeframe === 'i3' || quote.timeframe === 'i5' || quote.timeframe === 'i15') {
      if (!quote.hasOwnProperty('drawMinutesPerDay')) {
        quote.drawMinutesPerDay = quote.timeframe === 'i15' ? 390 : 420
      }

      if (!quote.hasOwnProperty('marketStartMinutes')) {
        quote.marketStartMinutes = quote.timeframe === 'i15' ? 570 : 540
      }

      if (!quote.hasOwnProperty('premarketLengthMinutes')) {
        quote.premarketLengthMinutes = quote.timeframe === 'i15' ? 0 : 30
      }

      if (!quote.hasOwnProperty('aftermarketLengthMinutes')) {
        quote.aftermarketLengthMinutes = 0
      }
    }

    if (!quote.hasOwnProperty('hasPatterns')) {
      quote.hasPatterns = hasPatterns
    }

    quote.ideaID = ideaChart.idea.id

    Quote.create<Quote>(quote)
  }
}
